import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitPreferenceStep2Page } from './init-preference-step2';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    InitPreferenceStep2Page,
  ],
  imports: [
    IonicPageModule.forChild(InitPreferenceStep2Page),
    PipesModule,
    DirectivesModule,

  ],
})
export class InitPreferenceStep2PageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-preference-step2/init-preference-step2.module.ts